import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { DeviceCommands } from '../types/availableCommand';
import { Command, CommandOrigin, CommandReportOffline, HistoricCommand } from '../types/command';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getHistoricCommands = async (
  page: number,
  search?: string,
  startDate?: number | null,
  endDate?: number | null,
  status?: string,
  commandType?: string,
  commandOrigin?: CommandOrigin,
  download?: boolean
): Promise<{ commands?: HistoricCommand[]; error?: ApiError; total?: number }> => {
  const queryParams = {
    page,
    status,
    commandType,
    startDate,
    endDate,
    commandOrigin,
    download: download ? true : undefined,
    q: search,
  };
  const response = await getRequest(
    URLS.commands.historic,
    {
      queryParams,
    },
    ApiEndpoint.core
  );
  return {
    total: response?.data?.total,
    commands: response?.data?.items,
    error: response?.error,
  };
};

export const getAvailableCommands = async (): Promise<{ commands?: Command[]; error?: ApiError }> => {
  const response = await getRequest(URLS.commands.all, {}, ApiEndpoint.core);
  return {
    commands: response?.data,
    error: response?.error,
  };
};

export const getCommandsReports = async (
  page: number,
  startDate?: number | null,
  endDate?: number | null
): Promise<{ commands?: CommandReportOffline[]; error?: ApiError; total?: number }> => {
  const queryParams = {
    page,
    startDate,
    endDate,
  };
  const response = await getRequest(
    URLS.commands.reports,
    {
      queryParams,
    },
    ApiEndpoint.core
  );
  return {
    total: response?.data?.total,
    commands: response?.data?.items,
    error: response?.error,
  };
};

export const downloadCommandsReportFile = async (reportId: string): Promise<{ url?: string; error?: ApiError }> => {
  const response = await getRequest(URLS.commands.downloadReport(reportId), {}, ApiEndpoint.core);
  return {
    url: response?.data?.url,
    error: response?.error,
  };
};

export const getDeviceCommands = async (assetId: string): Promise<{ devices?: DeviceCommands[]; error?: ApiError }> => {
  const response = await getRequest(URLS.commands.availables(assetId), {}, ApiEndpoint.core);
  return {
    devices: response?.data?.devices,
    error: response?.error,
  };
};

export const postCommand = async (
  assetId: string,
  ident: string,
  command: string
): Promise<{ commandId?: string; error?: ApiError }> => {
  const response = await postRequest(
    URLS.commands.send(assetId),
    {
      body: {
        command,
        ident,
      },
    },
    ApiEndpoint.core
  );

  return {
    commandId: response?.data?.commandId,
    error: response?.error,
  };
};
